import { flatMap, filter } from 'rxjs/operators';
import { of, EMPTY } from 'rxjs';
import { ofType, combineEpics } from 'redux-observable';
import { push } from 'connected-react-router';
import { PROFILE_STATUSES, GB_REGISTRATION_STATUSES, ACCOUNT_STATUSES } from '@clearscore/constants.profile-statuses';
import { selectors as routeSelectors } from '@clearscore/redux.routes';
import { types } from '@clearscore/redux.profile';

const INCORRECT_PHONE_NUMBER = 'INCORRECT_PHONE_NUMBER';
const INCORRECT_EMAIL_ADDRESS = 'INCORRECT_EMAIL_ADDRESS';
const myAccountPath = '/registration/my-account';
const OTPMaskedPath = '/otp/masked';

const shouldSkipRedirect = (state, payload) => {
    const profileStatus = payload.accountIDVStatus;
    const currentPath = routeSelectors.getCurrentPath(state);
    const isMyAccount = currentPath.includes(myAccountPath);
    const isOTPMasked = currentPath.includes(OTPMaskedPath);
    const isOTPMaskedIncorrectNumber = isOTPMasked && profileStatus === INCORRECT_PHONE_NUMBER;
    const isOTPMaskedIncorrectEmail = isOTPMasked && profileStatus === INCORRECT_EMAIL_ADDRESS;
    const hasNoProfileStatus = !GB_REGISTRATION_STATUSES.includes(profileStatus) && !PROFILE_STATUSES[profileStatus];

    if (isMyAccount || isOTPMaskedIncorrectNumber || isOTPMaskedIncorrectEmail || hasNoProfileStatus) {
        return false;
    }

    return true;
};

const redirect = (state, { userStatus }) => {
    if (userStatus === ACCOUNT_STATUSES.DUP_LOCKED) {
        return of(push('/reg/duplock'));
    }

    const { path } = routeSelectors.getRouteByIDVStatus(state).route;
    if (path) {
        return of(push(path));
    }

    return EMPTY;
};

/**
 * @description Middleware to handle create account registration on profile success
 * @param {Observable<Action>} action$ Observable
 * @param {Observable<State>} state$ Observable
 * @returns {Observable<Action>} Observable
 */
const stageRedirectProfileSuccessEpic = (action$, state$) =>
    action$.pipe(
        ofType(types.PROFILE_FETCH_SUCCESS),
        filter(({ payload }) => shouldSkipRedirect(state$.value, payload)),
        flatMap(({ payload }) => redirect(state$.value, payload)),
    );

/**
 * @description Middleware to handle push to login on profile error
 * @param {Observable<Action>} action$ Observable
 * @returns {Observable<Action>} Observable
 */
const stageRedirectProfileErrorEpic = (action$) =>
    action$.pipe(
        ofType(types.PROFILE_FETCH_ERROR),
        flatMap(() => of(push('/login'))),
    );

export default combineEpics(stageRedirectProfileSuccessEpic, stageRedirectProfileErrorEpic);
